import { Directive, OnInit, HostListener } from '@angular/core';

@Directive({
    selector: '[alphaNumericDirective]'
})

export class AlphaNumericDirective implements OnInit {

    ngOnInit() {

    }

    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('keydown', ['$event']) onKeyDown(event: any) {
        let k = event.target.value + event.key;

        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArroDown', 'Backspace', 'Tab', 'Alt',
            'Shift', 'Control', 'Enter', 'Delete', 'Meta'].includes(event.key)) return;

        let re = new RegExp('^[a-zA-Z0-9]*$');

        if (!re.test(k)) event.preventDefault();
    }
}